<template>
    <div class="customer__info">
        <toggle-card heading="Реквизиты" v-bind:visibility="true">
            <z-select
                v-model="localValue.type" name="type" id="type"
                v-validate="{required: true}" v-bind:error="errors.first('type')" data-vv-name="type" v-bind:data-vv-as="' '"
            >
                <option value='' selected disabled>Укажите тип</option>
                <option :value="1">Юридическое лицо</option>
                <option :value="2">Физическое лицо</option>
                <option :value="3">Индивидуальный предприниматель</option>
            </z-select>

            <z-input-autocomplete
                v-show="(localValue.type === 1 || localValue.type === 3)"
                v-model="localValue.inn" v-on:select="selectCustomer" v-on:clear="clearCustomer"
                v-validate="{required: (localValue.type === 1 || localValue.type === 3), length: (localValue.type === 3 ? 12 : 10)}"
                v-bind="{
                    id: 'inn', name: 'inn', label: 'ИНН',
                    required: true, error: errors.first('inn'), 'data-vv-as': ' ',
                    property: 'inn', 'display-property': 'ul_inn_label', 'data-vv-name': 'inn',
                    callback: searchCustomerByInn, 'length-on-search': 10, 'update-on-input': true, default: localValue.inn
                }"
            ></z-input-autocomplete>
            <z-input
                v-show="parseInt(localValue.type) === 2" name="passport_number" id="passport_number" 
                label="Номер паспорта" v-model="localValue.passport_number" required v-bind:minlength="12" v-bind:maxlength="12"
                v-bind:error="errors.first('passport_number')" :mask="{regex: '[A-zА-я0-9]{2} [0-9]{2} [0-9]{6}'}"
                v-validate="{required: (parseInt(localValue.type) === 2), passport: true}" data-vv-name="passport_number" v-bind:data-vv-as="' '"
            ></z-input>
            <z-input
                v-show="localValue.type === 1" v-validate="{required: (localValue.type === 1), length: (localValue.type === 1 ? 9 : false)}" v-bind:error="errors.first('kpp')"
                name="kpp" id="kpp" label="КПП" v-model="localValue.kpp" required data-vv-name="kpp" v-bind:data-vv-as="' '"
            ></z-input>
            <z-input
                name="name" id="name" v-model="localValue.name" required v-validate="'required|min:2'" v-bind:error="errors.first('name')"
                v-bind:label="((localValue.type === 1 || localValue.type === 3) ? 'Название' : 'ФИО')" data-vv-name="name" v-bind:data-vv-as="' '"
            ></z-input>
            <z-input
                name="doc_address" id="doc_address" v-model="localValue.doc_address"  v-validate="'min:1|max:1000'" 
                label="Адрес для документов" v-bind:error="errors.first('doc_address')" data-vv-name="doc_address" v-bind:data-vv-as="' '"
            ></z-input>
        </toggle-card>
        <toggle-card heading="Контактные даннные" v-bind:visibility="true">
            <z-input
                name="phone" id="phone" label="Номер телефона" v-model="localValue.phone" 
                v-validate="{required: false, regex: phoneValidate}" mask="+7 (999) 999-99-99"
                v-bind:error="errors.first('phone')" data-vv-name="phone" v-bind:data-vv-as="' '"
            ></z-input>
            <z-input
                name="email" id="email" label="Email адрес" v-model="localValue.email" 
                v-validate="{required: false, email: true}" data-vv-name="email" v-bind:data-vv-as="' '"
                v-bind:error="errors.first('email')"
            ></z-input>
        </toggle-card>
        <toggle-card heading="Банковские реквизиты">
            <z-select v-model="localValue.nds">
                <option value="" disabled selected>Не выбрано</option>
                <option :value="0">Без НДС</option>
                <option :value="1">C НДС</option>
            </z-select>
            <z-input
                name="checking_account" id="checking_account" label="Р/счёт" v-model="localValue.checking_account" type="number"
                v-bind:error="errors.first('checking_account')"  data-vv-name="checking_account" v-bind:data-vv-as="' '"  v-validate="{required: false, integer: true, min: 5}"
            ></z-input>
            <z-input
                name="correspondent_account" id="correspondent_account" label="К/счёт" v-model="localValue.correspondent_account" 
                v-bind:error="errors.first('correspondent_account')" type="number" v-validate="{required: false, integer: true, min: 3}"
            ></z-input>
            <div class="row">
                <z-input class="col-6" name="bank" id="bank" label="Банк" v-model="localValue.bank"></z-input>
                <z-input
                    class="col-6" name="bic" id="bic" label="Бик" type="number" 
                    v-model="localValue.bic" v-bind:error="errors.first('bic')" v-validate="{required: false, integer: true, min: 3}"
                ></z-input>
            </div>
        </toggle-card>
        <toggle-card heading="Дополнительная информация">
            <z-select v-model="localValue.is_agent">
                <option value="" disabled selected>Не выбрано</option>
                <option :value="0"> Клиент </option>
                <option :value="1"> Перевозчик </option>
            </z-select>

            <md-content v-bind:class="{ 'md-invalid': errors.has('contract') }">
                <label> Договор </label>
                <z-input v-model="localValue.contract" name="contract"></z-input>
                <span class="md-error" v-show="errors.has('contract')"> {{ errors.first('contract') }}</span>
            </md-content>
            <md-content v-bind:class="{ 'md-invalid': errors.has('groups') }">
                <label> Группы </label>
                <z-select v-model="localValue.group_ids" name="groups" multiple placeholder="Не выбрано">
                    <option value="" disabled selected>Не выбрано</option>
                    <option v-for="group in groups" v-bind:key="group.id" v-bind:value="group.id"> {{ group.name }}</option>
                </z-select>
                <span class="md-error" v-show="errors.has('groups')"> {{ errors.first('groups') }}</span>
            </md-content>
        </toggle-card>
    </div>
</template>
<script>
    import ZInput     from '@/components/ZInput';
    import ZSelect    from '@/components/ZSelect';
    import ToggleCard from '@/components/ToggleCard';
    import ZInputAutocomplete from '@/components/ZInputAutocomplete';
    export default {
        components: { ZInput, ToggleCard, ZSelect, ZInputAutocomplete },
        props: {
            value: {
                type: Object,
                default: () => {
                    return {};
                }
            }
        },
        data() {
            return {
                phoneValidate: /^\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}$/,
                localValue: {},
            }
        },
        computed: {
            /**
             * Получение групп контрагентов
             */
            groups() {
                return this.$store.state.customers.groups;
            },
        },
        created() {
            if (this.$props.value) 
                this.localValue = Object.assign({}, this.$props.value);
        },
        watch: {
            '$props.value' (newVal) {
                if (JSON.stringify(this.localValue) != JSON.stringify(newVal)) this.localValue = newVal;
            },
            'localValue' (newVal) {
                this.$emit('input', newVal)
            }
        },
        methods: {
            /**
             * Выбор контрагента
             */
            selectCustomer(inn, value) {
                if (!inn || !value) return;
                this.localValue.type  = parseInt(value.type);
                this.localValue.inn  = inn;
                this.localValue.name = (value.name) ? value.name : null;
                this.localValue.kpp  = (value.kpp)  ? value.kpp  : null;
                this.localValue.hid  = (value.hid)  ? value.hid  : null;
                this.localValue.passport_number = null;
            },
            /**
             * Сброс контрагента
             */
            clearCustomer() {
                this.localValue.inn  = null;
                this.localValue.name = null;
                this.localValue.kpp  = null;
                this.localValue.hid  = null;
            },
            /**Поиск контрагента по ИНН
             * 
             */
            searchCustomerByInn(inn) {
                return this.$store.dispatch('customers/suggestCustomersByInn', {inn: inn}).then(customers => {
                    if (!customers) return [];
                    customers.map(item => {
                        item.ul_inn_label = item.inn + ': ' + item.name;
                        item.ul_name_label = item.name + ': ' + item.inn;
                        return item;
                    });
                    return customers;
                }, () => []);
            },
            /**
             * Валидация
             */
            validate() {
                return this.$validator.validateAll();
            }
        }
    }
</script>
<style lang="sass"></style>


// WEBPACK FOOTER //
// CustomerInformation.vue?0a00e2b9